<template>
	<div class="prescription">
		<v-row no-gutters align="center">
			<v-btn color="primary" @click="showPatient = !showPatient">
				<v-icon left>person</v-icon>
				<translate>Patient</translate>
			</v-btn>
			<a
				color="primary"
				fab
				x-small
				dark
				class="ml-2"
				@click="showPrintOptions = true"
			>
				<v-icon>print</v-icon>
			</a>
			<v-dialog v-model="showPrintOptions" max-width="40%">
				<v-card>
					<v-card-title class="title primary--text mb-2 secondary">
						<translate>Print Prescription</translate>
						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-btn class="float-right" icon v-on="on">
									<v-icon color="primary">info_outline</v-icon>
								</v-btn>
							</template>
							<strong v-translate>Note</strong>:
							<span
								class="ml-1"
								v-translate
							>To download the files you need to allow pop-up windows on your browser</span>
						</v-tooltip>
					</v-card-title>
					<v-card-text>
						<v-radio-group v-model="paperSize" row>
							<v-radio label="A4" value="a4"></v-radio>
							<v-radio label="A5" value="a5"></v-radio>
						</v-radio-group>
						<v-list flat>
							<v-list-item-group>
								<v-list-item
									:disabled="isDisabled(option)"
									v-for="option in printOptions"
									:key="option.name"
									style="border: 1px solid #e0e0e0; border-radius: 5px"
									@click="selectOption(option)"
								>
									<v-list-item-icon class="mr-3">
										<v-icon color="primary">{{option.icon}}</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>
											<strong>{{getName(option)}}</strong>
										</v-list-item-title>
									</v-list-item-content>
									<v-list-item-action>
										<v-row no-gutters align="center">
											<v-checkbox v-model="option.selected" @click="selectOption(option)" color="primary"></v-checkbox>
										</v-row>
									</v-list-item-action>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="primary darken-1" text @click="showPrintOptions = false">
							<translate>Close</translate>
						</v-btn>
						<v-btn :disabled="!optionsSelected" color="primary" @click="getPrescription">
							<translate>Print</translate>
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-row>
		<v-row v-if="showPatient" no-gutters class="mt-5" align="center">
			<v-col class="px-1" cols="12" sm="8">
				<v-form ref="patientEmail" v-model="validPatientEmail">
					<v-text-field v-model="patient.email" label="Email" outlined hide-details :rules="[required]"></v-text-field>
				</v-form>
			</v-col>
			<v-col class="px-1" cols="12" sm="4">
				<v-btn color="primary" @click="clickSendPatientEmail" :loading="sendingEmail">
					<translate>Send</translate>
				</v-btn>
			</v-col>
			<p v-if="emailSent" class="green--text mt-3 mb-0" v-translate>Email sent!</p>
			<p v-if="error" class="red--text mt-3 mb-0" v-translate>Error</p>
			<v-dialog v-model="showSendOptions" max-width="40%">
				<v-card>
					<v-card-title class="title primary--text mb-2 secondary">
						<translate>Send</translate>
					</v-card-title>
					<v-card-text>
						<v-list flat>
							<v-list-item-group>
								<v-list-item
									:disabled="isDisabled(option)"
									v-for="option in printOptions"
									:key="option.name"
									style="border: 1px solid #e0e0e0; border-radius: 5px"
									@click="selectOption(option)"
								>
									<v-list-item-icon class="mr-3">
										<v-icon color="primary">{{option.icon}}</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>
											<strong>{{getName(option)}}</strong>
										</v-list-item-title>
									</v-list-item-content>
									<v-list-item-action>
										<v-row no-gutters align="center">
											<v-checkbox v-model="option.selected" @click="selectOption(option)" color="primary"></v-checkbox>
										</v-row>
									</v-list-item-action>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="primary darken-1" text @click="showSendOptions = false">
							<translate>Close</translate>
						</v-btn>
						<v-btn :disabled="!optionsSelected" color="primary" @click="sendEmail(false)">
							<translate>Send</translate>
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-row>
		<!-- <v-row no-gutters class="mt-5">
			<v-btn color="primary">
				<v-icon left>store</v-icon>
				<translate>Provider</translate>
			</v-btn>
		</v-row> -->
		<v-row no-gutters class="mt-5" align="center">
			<v-btn color="primary" @click="showLaboratory = !showLaboratory" :disabled="!existCustomFormulas">
				<v-icon left>eco</v-icon>
				<translate>Laboratory</translate>
			</v-btn>
			<a
				v-if="existCustomFormulas"
				color="primary"
				fab
				x-small
				dark
				class="ml-2"
				@click="showLaboratoryPrintOptions = true"
			>
				<v-icon>print</v-icon>
			</a>
		</v-row>
		<v-row v-if="showLaboratory && existCustomFormulas" no-gutters align="center" class="mt-5">
			<v-col class="px-1" cols="12" sm="8">
				<v-form ref="laboratoryEmail" v-model="validLaboratoryEmail">
					<v-text-field v-model="laboratoryEmail" label="Email" outlined hide-details :rules="[required]"></v-text-field>
				</v-form>
			</v-col>
			<v-col class="px-1" cols="12" sm="4">
				<v-btn color="primary" @click="clickSendLaboratoryEmail" :loading="sendingEmail">
					<translate>Send</translate>
				</v-btn>
			</v-col>
			<p v-if="laboratoryEmailSent" class="green--text mt-3 mb-0" v-translate>Email sent!</p>
			<p v-if="laboratoryError" class="red--text mt-3 mb-0" v-translate>Error</p>
		</v-row>
		<v-dialog v-model="showLaboratoryPrintOptions" max-width="40%">
				<v-card>
					<v-card-title class="title primary--text mb-2 secondary">
						<translate>Print Formulas</translate>
						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-btn class="float-right" icon v-on="on">
									<v-icon color="primary">info_outline</v-icon>
								</v-btn>
							</template>
							<strong v-translate>Note</strong>:
							<span
								class="ml-1"
								v-translate
							>To download the files you need to allow pop-up windows on your browser</span>
						</v-tooltip>
					</v-card-title>
					<v-card-text>
						<v-radio-group v-model="paperSize" row>
							<v-radio label="A4" value="a4"></v-radio>
							<v-radio label="A5" value="a5"></v-radio>
						</v-radio-group>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="primary darken-1" text @click="showLaboratoryPrintOptions = false">
							<translate>Close</translate>
						</v-btn>
						<v-btn color="primary" @click="getLaboratoryPrescription">
							<translate>Print</translate>
						</v-btn>
					</v-card-actions>
				</v-card>
		</v-dialog>
	</div>
</template>

<script>
import axios from "axios";

export default {
	name: "Prescription",
	props: ["patient", "existSupplements", "existNutrition", "existQiGong", "existCustomFormulas"],
	data: () => ({
		showPatient: false,
		sendingEmail: false,
		emailSent: false,
		error: false,
		showPrintOptions: false,
		showSendOptions: false,
		showLaboratory: false,
		showLaboratoryPrintOptions: false,
		laboratoryEmail: "",
		laboratoryEmailSent: false,
		laboratoryError: false,
		validPatientEmail: false,
		validLaboratoryEmail: false,
		paperSize: "a4",
		printOptions: [
			{
				name: "Supplements",
				icon: "mdi-pill",
				selected: false,
				code: "products"
			},
			{
				name: "Nutrition",
				icon: "mdi-food-fork-drink",
				selected: false,
				code: "nut"
			},
			{ name: "Qi Gong",
				icon: "mdi-yoga",
				selected: false,
				code: "qg"
			}
		]
	}),
	computed: {
		optionsSelected() {
			return this.printOptions.filter(op => op.selected).length > 0;
		},
		selectedCategories() {
			return this.printOptions.filter(
				op => op.selected && !this.isDisabled(op)
			);
		},
		required() {
			return value => !!value || this.$gettext("Required.");
		}
	},
	methods: {
		isDisabled(option) {
			if (option.code == "products" && !this.existSupplements) return true;
			else if (option.code == "nut" && !this.existNutrition) return true;
			else if (option.code == "qg" && !this.existQiGong) return true;
			else return false;
		},
		getName(option) {
			if (option.code == "products") return this.$gettext("Supplements");
			if (option.code == "nut") return this.$gettext("Nutrition");
			else return option.name;
		},
		selectOption(option) {
			option.selected = !option.selected;
		},
		sendEmail(laboratory) {
			this.showSendOptions = false;
			this.sendingEmail = true;
			this.emailSent = false;
			this.error = false;
			this.laboratoryEmailSent = false;
			this.laboratoryError = false;
			const appointmentId = this.$route.params.aid;
			const patientId = this.$route.params.pid;
			const formData = new FormData();
			if(laboratory) formData.append("send_email", this.laboratoryEmail);
			else formData.append("send_email", this.patient.email);
			formData.append("paper_size", this.paperSize);
			if(laboratory) {
				formData.append("laboratory", true);
			} else {
				this.selectedCategories.forEach(c => {
					formData.append(c.code, true);
				});
			}
			axios
				.post(
					"/patient/" +
						patientId +
						"/appointment/" +
						appointmentId +
						"/send_posology",
					formData
				)
				.then(response => {
					if (response.status === 200) {
						console.log(response.data)
						if (response.data.result === "sent") {
							if(laboratory) this.laboratoryEmailSent = true;
							else this.emailSent = true;
						} else {
							if(laboratory) this.laboratoryError = true;
							else this.error = true;
						}
					}
					this.sendingEmail = false;
				})
				.catch(error => {
					console.log(error);
					if(laboratory) this.laboratoryError = true;
					else this.error = true;
					this.sendingEmail = false;
				});
		},
		getPrescription() {
			this.showPrintOptions = false;
			const appointmentId = this.$route.params.aid;
			const patientId = this.$route.params.pid;
			var categories = this.selectedCategories;
			categories.forEach(c => {
				var link = document.createElement("a");
				link.href =
					"https://api.naltio.com/patient/" +
					//"http://127.0.0.1:5500/patient/" +
					patientId +
					"/appointment/" +
					appointmentId +
					"/posology?category=" +
					c.code +
					"&paper_size=" +
					this.paperSize;
				//link.target = "_self";
				//document.body.appendChild(link);
				//link.click();
				window.open(link.href);
			});
		},
		clickSendPatientEmail() {
			if(this.$refs.patientEmail.validate()) {
				this.showSendOptions = true;
			}
		},
		clickSendLaboratoryEmail() {
			if(this.$refs.laboratoryEmail.validate()) {
				this.sendEmail(true);
			}
		},
		getLaboratoryPrescription() {
			this.showLaboratoryPrintOptions = false;
			const appointmentId = this.$route.params.aid;
			const patientId = this.$route.params.pid;
			var link = document.createElement("a");
			link.href =
				"https://api.naltio.com/patient/" +
				//"http://127.0.0.1:5500/patient/" +
				patientId +
				"/appointment/" +
				appointmentId +
				"/posology?category=" +
				"laboratory" +
				"&paper_size=" +
				this.paperSize;
				//link.target = "_self";
				//document.body.appendChild(link);
				//link.click();
				window.open(link.href);
		}
	},
	created() {
		this.$root.$on('tour-prescription-print-options', () => {
			this.showPatient = true;
			this.showPrintOptions = true;
		});
		this.$root.$on('tour-prescription-print', () => {
			this.printOptions[0].selected = true;
			this.getPrescription();
		});
	}
};
</script>